<template>
<div class="w-16">

	<div class="flex flex-col bg-grey-darker shadow-md">

		<div class="tooltip m-px">
			<button @click="openModal('customer-sampling')" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current"><path class="heroicon-ui" d="M14 5.62l-4 2v10.76l4-2V5.62zm2 0v10.76l4 2V7.62l-4-2zm-8 2l-4-2v10.76l4 2V7.62zm7 10.5L9.45 20.9a1 1 0 0 1-.9 0l-6-3A1 1 0 0 1 2 17V4a1 1 0 0 1 1.45-.9L9 5.89l5.55-2.77a1 1 0 0 1 .9 0l6 3A1 1 0 0 1 22 7v13a1 1 0 0 1-1.45.89L15 18.12z"/></svg>
			</button>
			<span class="tooltiptext">Lägg till fält</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="openModal('add-text')" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6 text-grey-darker fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 17.981h-13l-7 5.02v-5.02h-4v-16.981h24v16.981zm-2-14.981h-20v12.981h4v3.125l4.357-3.125h11.643v-12.981zm-9 6.001v5h-2v-5h2zm-1-1.5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z"/></svg>
			</button>
			<span class="tooltiptext">Lägg till kundinformation</span>
		</div>

		<div class="tooltip m-px">
			<button @click="addTextField()" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current"><path class="heroicon-ui" d="M6.3 12.3l10-10a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-.7.3H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 .3-.7zM8 16h2.59l9-9L17 4.41l-9 9V16zm10-2a1 1 0 0 1 2 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a1 1 0 0 1 0 2H4v14h14v-6z"/></svg>
			</button>
			<span class="tooltiptext">Lägg till en textruta</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="openModal('add-image')" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current"><path class="heroicon-ui" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm16 8.59V6H4v6.59l4.3-4.3a1 1 0 0 1 1.4 0l5.3 5.3 2.3-2.3a1 1 0 0 1 1.4 0l1.3 1.3zm0 2.82l-2-2-2.3 2.3a1 1 0 0 1-1.4 0L9 10.4l-5 5V18h16v-2.59zM15 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>
			</button>
			<span class="tooltiptext">Lägg till bild</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="openModal('page-settings')" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6 text-grey-darker fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 14.187v-4.374c-2.148-.766-2.726-.802-3.027-1.529-.303-.729.083-1.169 1.059-3.223l-3.093-3.093c-2.026.963-2.488 1.364-3.224 1.059-.727-.302-.768-.889-1.527-3.027h-4.375c-.764 2.144-.8 2.725-1.529 3.027-.752.313-1.203-.1-3.223-1.059l-3.093 3.093c.977 2.055 1.362 2.493 1.059 3.224-.302.727-.881.764-3.027 1.528v4.375c2.139.76 2.725.8 3.027 1.528.304.734-.081 1.167-1.059 3.223l3.093 3.093c1.999-.95 2.47-1.373 3.223-1.059.728.302.764.88 1.529 3.027h4.374c.758-2.131.799-2.723 1.537-3.031.745-.308 1.186.099 3.215 1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223.3-.726.88-.763 3.027-1.528zm-4.875.764c-.577 1.394-.068 2.458.488 3.578l-1.084 1.084c-1.093-.543-2.161-1.076-3.573-.49-1.396.581-1.79 1.693-2.188 2.877h-1.534c-.398-1.185-.791-2.297-2.183-2.875-1.419-.588-2.507-.045-3.579.488l-1.083-1.084c.557-1.118 1.066-2.18.487-3.58-.579-1.391-1.691-1.784-2.876-2.182v-1.533c1.185-.398 2.297-.791 2.875-2.184.578-1.394.068-2.459-.488-3.579l1.084-1.084c1.082.538 2.162 1.077 3.58.488 1.392-.577 1.785-1.69 2.183-2.875h1.534c.398 1.185.792 2.297 2.184 2.875 1.419.588 2.506.045 3.579-.488l1.084 1.084c-.556 1.121-1.065 2.187-.488 3.58.577 1.391 1.689 1.784 2.875 2.183v1.534c-1.188.398-2.302.791-2.877 2.183zm-7.125-5.951c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"/></svg>
			</button>
			<span class="tooltiptext">Öppna sidoinställningar</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="createTemplate()" class="w-full flex-1 text-grey-darker text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6  fill-current text-grey-darker" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 9h2v6h-2v-6zm9.362-7c4.156 0 2.638 6 2.638 6s6-1.65 6 2.457v4.543h2v-5.386c0-2.391-6.648-9.614-9.811-9.614h-3.189v2h2.362zm-7.362 5v-5h3v-2h-5v7h2zm0 15v-5h-2v7h5v-2h-3zm16-5v5h-3v2h5v-7h-2zm-11 5v2h6v-2h-6z"/></svg>
			</button>
			<span class="tooltiptext">Skapa ny sida med denna som mall</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="sendLayerBack()" class="w-full flex-1 text-grey-darker text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6  fill-current text-grey-darker" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24-4v20h2v-18h18v-2h-20zm18 13h-8v2h8v-2z"/></svg>
			</button>
			<span class="tooltiptext">Skicka bakåt</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="sendLayerForward()" class="w-full flex-1 text-grey-darker text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6  fill-current text-grey-darker" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24-4v20h2v-18h18v-2h-20zm18 13h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z"/></svg>
			</button>
			<span class="tooltiptext">Skicka framåt</span>
		</div>
		
		<div class="tooltip m-px">
			<button @click="removePage()" class="text-grey-darker w-full text-center bg-grey-light hover:bg-grey p-1">
				<svg class="h-6 w-6  fill-current text-grey-darker" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 19c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5-17v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712zm-3 4v16h-14v-16h-2v18h18v-18h-2z"/></svg>
			</button>
			<span class="tooltiptext">Ta bort denna sida</span>
		</div>
	</div>

</div>
</template>

<script>

export default {
	name: 'sidebar',

	props: ['page_id'],

	methods: {

		openModal(modalName) {
        	bus.$emit('open-' + modalName + '-modal', this.page_id)
		},

		addTextField() {
			bus.$emit('add-textfield', this.page_id)
		},

		removePage() {
			if(confirm("Är du säker på att du vill ta bort sidan")) {
				this.$store.dispatch("layout/REMOVE_PAGE", this.page_id)
			}
		},

		createTemplate() {
			this.$store.dispatch("layout/ADD_NEW_PAGE_FROM_ACTIVE_PAGE", this.page_id);
		},

		sendLayerBack() {
			bus.$emit('send-to-back', this.page_id)
		},

		sendLayerForward() {
			bus.$emit('send-to-front', this.page_id)
		},
	}

}
</script>